var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.url)?_c('div',{staticClass:"qr-code-image text-center"},[_c('img',{attrs:{"src":_vm.url}}),(!!_vm.label)?_c('div',{staticClass:"text-gray text-small"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }